export enum UnitsType {
  Ton = 'TON',
  KG = 'KG',
  Box = 'BOX',
}